// extracted by mini-css-extract-plugin
export default {"container":"style_container__f+2bL","content":"style_content__bnCGK","title":"style_title__svZ05","message":"style_message__9IIxb","subtext":"style_subtext__-4-5m"};